/**************************************************
 * Nombre:       PorMayor_Compra
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {NEGRITA} from "../../../Constantes";
import {theme} from "../../../Tema";
import empa from '../../../Recursos/empananda.svg'
import {useFormulario} from "../../../Modulo_formularios/Hooks/useFormulario";
import Formulario_Mayorista from "../../Formularios/Formulario_Mayorista";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {useCargador} from "../../../Modulo_Cargador/Hooks/useCargador";
import logo from '../../../Recursos/logo_redondo.svg'
import {guardarDoc} from "../../../Servicios/BD/guardarDoc";
import {envioNotificacionMayoristas} from "../../../Utilidades/envioNotificacionMayoristas";

const PorMayor_Compra = () => {
    const {sCell} = useResponsive()
    const {props, obtenerEntidad, limpiarEntidad, setEntidad} = useFormulario({valoresDefecto: {}})
    const {Cargador, Avisos, iniciarCarga, terminar} = useCargador({logoRedondo: logo, funcionUno: setEntidad})

    const subirDatos = async () => {

        let entidad = await obtenerEntidad()
        entidad.estado = 'Nuevo'
        iniciarCarga('Subiendo datos')
        let dox = await guardarDoc('mayoristas', entidad)
        await envioNotificacionMayoristas(entidad)
        if (dox.res) {
            terminar({aviso: 'Datos enviados'})
        } else {
            terminar({aviso: 'Algo salio mal, intentalo mas tarde', variante: 'error'})
        }

    }

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Cargador/>

            <Avisos/>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={8}
                    >

                        <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={0}
                            >

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: sCell ? "center" : 'flex-start'}}>
                                    <Typography
                                        sx={{
                                            fontFamily: NEGRITA,
                                            fontSize: sCell ? 24 : 32,
                                            color: theme.palette.primary.main,
                                            textAlign: sCell ? 'center' : 'left',
                                            lineHeight: 1.3
                                        }}>
                                        COMPRA AL POR MAYOR
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: sCell ? 2 : 0}}>
                                    <Typography
                                        sx={{fontSize: 18, fontWeight: 600, textAlign: sCell ? 'center' : 'left'}}>
                                        Ofrecemos productos congelados al por mayor, ideales para negocios y eventos.
                                        Llévate el sabor que nos caracteriza, listo para preparar y compartir.
                                    </Typography>
                                </Grid>

                                <Grid
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}
                                    sx={{mt: 4}}
                                >

                                    {items.map((item, index) => (
                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: 'flex-start', mt: 0.5}}>
                                            <Typography sx={{fontWeight: 600}}> <span>
                                                <img src={empa} width={25} height={'auto'}
                                                     style={{marginTop: 6, marginBottom: -6, paddingRight: 5}}/>
                                            </span> {item}</Typography>
                                        </Grid>
                                    ))}

                                </Grid>

                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={3}
                            >

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Formulario_Mayorista props={props}/>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                    <Button
                                        onClick={() => subirDatos()}
                                    >Contactame</Button>
                                </Grid>

                            </Grid>

                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default PorMayor_Compra

const items = [
    'Ahorro garantizado',
    'Calidad constante',
    'Ideal para negocios y eventos',
    'Apoyo local'
]